import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addressQualification } from "../../../../shared/hooks/useFetchCompleteAddress";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { getFailureCount, incrementFailureCount, resetFailureCount } from "../../Utils/failuretracking";
import DwLogutil from "../../Utils/DwLogutil";

type addressQualifucationInitialStateType = {
  data: any;
  loading: boolean;
  error: any;
  networkType: any;
  customAddressQualificationLoader: boolean,
};
const initialState: addressQualifucationInitialStateType = {
  data: null,
  loading: false,
  error: null,
  networkType: null,
  customAddressQualificationLoader: false,
};

export const getAddressQualification = createAsyncThunk(
  "get/address/qualification",
  async (user: any,{ rejectWithValue }) => {
       const failCount = getFailureCount();
    if (failCount >= 2) {
      return rejectWithValue('Blocked after 2 failures');
    }
    try {
      const serviceAdd = user?.addresses?.find(
        (addr: any) => addr?.addressType === "ServiceAddress"
      );
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      if (
        serviceAdd &&
        serviceAdd?.street &&
        serviceAdd?.city &&
        serviceAdd?.state &&
        serviceAdd?.addressId 
        && (!serviceAdd?.addressId?.toLowerCase()?.includes("ban")) 
      ) {
        let url=API_URLS?.addressQualificationURL;
        const addressQualificationResponse = await addressQualification(
          {
            "": `${url}?addressId=${serviceAdd?.addressId}&serviceInstanceId=${user?.serviceInstanceId || ""}&existingUser=EC`,
          },
          headers
        );
        if (
          addressQualificationResponse?.status === 200 
          // addressQualificationRes?.data && 
          // addressQualificationResponse?.data?.status !== 500 
          // && addressQualificationRes?.data?.entity
        ) {
          const addressQualificationRes = addressQualificationResponse?.data?.data 
                    ? addressQualificationResponse?.data 
                    : addressQualificationResponse  

          if(addressQualificationRes?.data?.entity?.instantInternet === true)
          {
            DwLogutil({stepName:"user with instantInternet logged in"})        
          }          
          if (addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]?.cpeDetails?.wifi6Router) {
            DwLogutil({ stepName: "user has wifi6 router" })
          }
          if (addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]?.cpeDetails?.wifi7Router) {
            DwLogutil({ stepName: "user has wifi7 router" })
          }
          resetFailureCount();
          return {
            addressQualification: addressQualificationRes?.data,
          };
        } else {
          
          throw new Error("Something went wrong with address qualification");
        }
      } else {
        throw new Error("Invalid user service address");
      }
    } catch (error:any) {
      const newCount = incrementFailureCount();
       DwLogutil({stepName:` addressqualification failed ${newCount} time(s) `,error:`${error.message}`})
       return rejectWithValue(`API call failed ${newCount} time(s): ${error.message}`);
    
    }
  }
);

const addressQualificationSlice = createSlice({
  name: "address/qualification",
  initialState,
  reducers: {
    clearAddressQualificationState: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    addressQualificationSliceSetInitialState: () => initialState,
    updateAddressQualificationSlice: (state, action) => {
      state.data = action.payload;
      if (action.payload?.addressQualification?.entity?.networkType) {
        state.networkType =
          action.payload?.addressQualification?.entity?.networkType;
      }
    },
    setAddressQualificationLoader: (state, action) => {
      state.customAddressQualificationLoader = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAddressQualification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAddressQualification.fulfilled, (state, action) => {
      state.data = action.payload;
      state.networkType =
        action.payload?.addressQualification?.entity?.networkType;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAddressQualification.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const {
  clearAddressQualificationState,
  addressQualificationSliceSetInitialState,
  updateAddressQualificationSlice,
  setAddressQualificationLoader
} = addressQualificationSlice.actions;
export default addressQualificationSlice.reducer;
